import { useEffect } from 'react';
import { Store, useStore } from 'react-stores';
import { sleep } from '../../utils';
import { listPhoneNumbers } from './service';
import PhoneNumber, { PhoneNumberStatus } from '../../models/PhoneNumber';

const callbacks = {
  refresh: [] as ((phoneNumbers: PhoneNumber[]) => any)[]
};

class PhoneNumberState {
  phoneNumbers: PhoneNumber[] = [];
  fetching = true;
  refreshCount = 0;

  /**
   * Will cause a re-fetch if this value changes.
   */
  _fetchTrigger?: number;
  refresh: () => Promise<PhoneNumber[]>;
}

export const globalPhoneNumberStore = new Store<PhoneNumberState>({
  ...new PhoneNumberState(),
  refresh: function () {
    globalPhoneNumberStore.setState({
      _fetchTrigger: Date.now()
    });

    return new Promise((resolve, reject) => {
      callbacks.refresh.push(resolve);
    });
  }
});

/**
 * Fetches phone numbers in the background.
 */
export default function PhoneNumberDispatcher() {
  const { phoneNumbers, _fetchTrigger } = useStore(globalPhoneNumberStore);

  async function refreshPhoneNumbers() {
    globalPhoneNumberStore.setState({
      fetching: true,
      refreshCount: globalPhoneNumberStore.state.refreshCount + 1
    });

    while (true) {
      try {
        var phoneNumbers = await listPhoneNumbers({});

        globalPhoneNumberStore.setState({
          phoneNumbers,
          fetching: false
        });

        callbacks.refresh.forEach(callback => callback(phoneNumbers));
        callbacks.refresh = [];

        break;
      } catch (e) {
        console.error(e);
        await sleep(5000);
      }
    }
  }

  const isAnticipatingPhoneNumberChange = !!phoneNumbers.find(phoneNumber =>
    phoneNumber.status === PhoneNumberStatus.Deleting || phoneNumber.status === PhoneNumberStatus.Creating ||
    phoneNumber.status === PhoneNumberStatus.Renewing);

  useEffect(() => {
    refreshPhoneNumbers();

    if (isAnticipatingPhoneNumberChange) {
      //  Refresh automatically.
      const refreshInterval = setInterval(() => refreshPhoneNumbers(), 10000);
      return () => { clearInterval(refreshInterval); }
    }
  }, [isAnticipatingPhoneNumberChange, _fetchTrigger]);

  return null;
}

export const usePhoneNumbers = () => useStore(globalPhoneNumberStore).phoneNumbers;